<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('privacy.Header') }}</h2>
                {{ $t('privacy.HeaderText') }}
                <br />
                <h3>{{ $t('privacy.LegalBasis') }}</h3>
                {{ $t('privacy.LegalBasisText') }}
                <br />
                <h3>{{ $t('privacy.RightToInformation') }}</h3>
                <br />
                {{ $t('privacy.RightToInformationText') }}
                <ul>
                    <li>{{ $t('privacy.RightToInformationList1') }}</li>
                    <li>{{ $t('privacy.RightToInformationList2') }}</li>
                    <li>{{ $t('privacy.RightToInformationList3') }}</li>
                    <li>{{ $t('privacy.RightToInformationList4') }}</li>
                    <li>{{ $t('privacy.RightToInformationList5') }}</li>
                    <li>{{ $t('privacy.RightToInformationList6') }}</li>
                    <li>{{ $t('privacy.RightToInformationList7') }}</li>
                    <li>{{ $t('privacy.RightToInformationList8') }}</li>
                </ul>
                <h3>{{ $t('privacy.StorageOfAccessdata') }}</h3>
                {{ $t('privacy.StorageOfAccessdataText') }}
                <h3>{{ $t('privacy.GoogleAnalytics') }}</h3>
                {{ $t('privacy.GoogleAnalyticsText') }}
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import { EventBus } from '@/classes/eventBus.js';

    export default {
        props: {
            linkItem: String,
            myText: String
        },
        data: function () {
            return {
                theImage: '',
            }
        },
        computed: {
        },
        mounted() {
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
        },
        methods: {
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>